import React from "react";
import style from "./Footer.module.css";

import footer from "../../../../Assets/img/footer.png";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { useMediaQuery } from "@material-ui/core";

export const Footer = () => {
  const mobile = useMediaQuery("(max-width:768px)");
  return (
    <div className={!mobile ? style.container : style.containerMob}>
      <div className={!mobile ? style.item1 : style.item1Mob}>
        <img
          src={footer}
          alt=""
          className={!mobile ? style.img : style.imgMob}
        />

        <div className={!mobile ? style.linksCont : style.linksContMob}>
          <a href="#conocenos" className={!mobile ? style.link : style.linkMob}>
            Cónocenos
          </a>
          <a href="#Submarcas" className={!mobile ? style.link : style.linkMob}>
            Submarcas
          </a>
          <a href="#Servicios" className={!mobile ? style.link : style.linkMob}>
            Servicios
          </a>
          <a href="#Contacto" className={!mobile ? style.link : style.linkMob}>
            Contactos
          </a>
        </div>

        <div className={!mobile ? style.infoCont : style.infoContMob}>
          <p className={style.txt}>
            {" "}
            {" "}
          </p>
          <p className={style.txt}>
            {" "}
            <WhatsAppIcon className={style.wsp}></WhatsAppIcon> 42371621{" "}
          </p>
          <p className={style.txt}> info@visnu.com.gt </p>
        </div>
      </div>

      <div className={style.item2}>
        <p className={style.txtBot}>
          {" "}
          Visnú 2021. Todos los derechos reservados. Sitio creado por Mango Verde.
        </p>
      </div>
    </div>
  );
};
